<template>
  <div @click="$emit('click', $event)">
    <img v-if="url" :src="url" :class="'user-avatar__' + size">
    <div v-else :class="'user-avatar__' + size">
      {{ name && name.length > 2 ? name.substr(name.length - 2, 2) : !name ? '无' : name }}
    </div>
  </div>
</template>

<script>
export default {
name: "userAvatar",
  props: {
    url: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    }
  },
}
</script>

<style scoped>
.user-avatar__ {
  cursor: default;
  width: 40px;
  height: 40px;
  background-color: #4480F3;
  font-size: 14px;
  color: white;
  text-align: center;
  line-height: 40px;
  border-radius: 50%;
}
.user-avatar__large {
  cursor: default;
  width: 120px;
  height: 120px;
  background-color: #4480F3;
  font-size: 20px;
  color: white;
  text-align: center;
  line-height: 120px;
  border-radius: 50%;
}
</style>
